export default "__VITE_ASSET__Dkugq5N5__"